module.exports = __webpack_public_path__ + "img/2_24.691f6625.jpg";